import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    posts_store: [],
    page_store: 0,
    more_store: 0,
    url_store: '',
    subtitle_store: null,
    total: 0
  },
  mutations: {
      posts_store(state, posts_store) {
          state.posts_store = posts_store
      },
      page_store(state, page) {
          state.page_store = page
      },
      more_store(state, more) {
          state.more_store = more
      },
      url_store(state, url) {
          state.url_store = url
      },
      subtitle_store(state, store) {
          state.subtitle_store = store
      },
      total(state, total) {
          state.total = total
      },
  }
});



// WEBPACK FOOTER //
// ./src/store.js